<template>
<div class="flex flex-wrap ">
<div class=" details-wrapper mr-0 md:mr-4 flex-grow-1">
         <div class="field col-12 ">
              <Dropdown v-model="selectedCategory" :options="devicescategory" optionLabel="name" optionValue="code" placeholder="Seleziona una Categoria" class="w-full"/>
          </div>
          <div class="field col-12 ">
          <span class="p-float-label mr-2">
            <InputText id="username" type="text" v-model="value2" class="w-full" />
            <label for="username">Seriale</label>
        </span>
          </div>
           <div class="field col-12">
             <label for="basic">Impianto</label>
         <Dropdown v-model="selectedImplant" :options="implants" optionLabel="name" :filter="true" placeholder="Seleziona Impianto" :showClear="true" class="w-full">
            <template #value="slotProps">
                <div class="country-item country-item-value" v-if="slotProps.value">
                    <div>{{slotProps.value.name}}</div>
                </div>
                <span v-else>
                    {{slotProps.placeholder}}
                </span>
            </template>
            <template #option="slotProps">
                <div class="country-item">
                    <div>{{slotProps.option.name}}</div>
                </div>
            </template>
        </Dropdown>
         </div>
          <div class="field col-12 ">
           <Dropdown v-model="selectedLots" :options="lots" optionLabel="name" :filter="true" placeholder="Seleziona Lotto" :showClear="true" class="w-full">
            <template #value="slotProps">
                <div class="country-item country-item-value" v-if="slotProps.value">
                    <div>{{slotProps.value.name}}</div>
                </div>
                <span v-else>
                    {{slotProps.placeholder}}
                </span>
            </template>
            <template #option="slotProps">
                <div class="country-item">
                    <div>{{slotProps.option.name}}</div>
                </div>
            </template>
        </Dropdown>
          </div>
          <div class="field col-12 ">
              <Dropdown v-model="selectedStatus" :options="statuses" optionLabel="name" optionValue="code" placeholder="Stato" class="w-full"/>
          </div>
</div>
<div class=" details-wrapper mr-0 md:mr-4 flex-grow-1">
        <div class="field col-12 ">
                <label for="basic">Data Attivazione</label>
                <Calendar id="basic" v-model="date1" autocomplete="off" :showIcon="true" class="w-full" />
            </div>
            <div class="field col-12 ">
                <label for="basic">Data Scadenza</label>
                <Calendar id="basic" v-model="date2" autocomplete="off" :showIcon="true" class="w-full" />
            </div>



</div>
</div>
<div class="mt-4">
<Button label="Salva" class="p-button-rounded mr-3" />
<Button label="Annulla" class="p-button-outlined p-button-secondary p-button-rounded" />
</div>
</template>
<script>

import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import Textarea from 'primevue/textarea';
import Calendar from 'primevue/calendar';
import MultiSelect from 'primevue/multiselect';


export default {
    components: {
        InputText,
        Button,
        Dropdown,
        Checkbox,
        Textarea,
        Calendar,
        MultiSelect
    },
          data() {
        return {
            date1: null,
            date2: null,
            selectedCategory: null,
            selectedStatus: null,
            selectedImplant: null,
            implants: [
                {name: 'Australia', code: 'AU'},
                {name: 'Brazil', code: 'BR'},
                {name: 'China', code: 'CN'},
                {name: 'Egypt', code: 'EG'},
                {name: 'France', code: 'FR'},
                {name: 'Germany', code: 'DE'},
                {name: 'India', code: 'IN'},
                {name: 'Japan', code: 'JP'},
                {name: 'Spain', code: 'ES'},
                {name: 'United States', code: 'US'}
            ],
            selectedLots: null,

            selectedItems: null,
            selectAll: false,
            devicescategory: [
                {name: 'Microcontrollore', code: '01'},
                {name: 'Trasmissione dati', code: '02'},
                {name: 'Stazione meteo', code: '03'},
                {name: 'Sonda suolo', code: '04'},
                {name: 'Sonda elettrovalvola', code: '05'},
                {name: 'Sonda serbatoio).', code: '06'}
            ],
            statuses: [
                {name: 'Non Raggiungibile', code: '01'},
                {name: 'Connesso', code: '02'},
                {name: 'Altro Stato', code: '03'},
            ],
            lots: [
                {name: 'Australia', code: 'AU'},
                {name: 'Brazil', code: 'BR'},
                {name: 'China', code: 'CN'},
                {name: 'Egypt', code: 'EG'},
                {name: 'France', code: 'FR'},
                {name: 'Germany', code: 'DE'},
                {name: 'India', code: 'IN'},
                {name: 'Japan', code: 'JP'},
                {name: 'Spain', code: 'ES'},
                {name: 'United States', code: 'US'}
            ],

            items: Array.from({ length: 1000 }, (_, i) => ({ label: `Item #${i}`, value: i }))
        }
    },
    methods: {
        onSelectAllChange(event) {
            this.selectedItems = event.checked ? this.items.map((item) => item.value) : [];
            this.selectAll = event.checked;
        },
        onChange(event) {
            this.selectAll = event.value.length === this.items.length
        }
    }
}
</script>
<style lang="scss" scoped>
.p-multiselect {
    width: 18rem;
}

::v-deep(.multiselect-custom) {
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: .25rem;
        padding-bottom: .25rem;
    }

    .country-item-value {
        padding: .25rem .5rem;
        border-radius: 3px;
        display: inline-flex;
        margin-right: .5rem;
        background-color: var(--primary-color);
        color: #000;

        img.flag {
            width: 17px;
        }
    }
}

@media screen and (max-width: 640px) {
    .p-multiselect {
        width: 100%;
    }
}
</style>
